// Core
import React, { useState, useRef, useEffect } from 'react';
import { Flex, Button, Box, Image, Grid, Text, Switch, Spinner, useDisclosure } from '@chakra-ui/react';
import { FaCoins } from 'react-icons/fa6';
import { SiCrystal } from 'react-icons/si';
import { useQuery } from 'react-query';

// Assets
import { apiService } from 'services/ApiService';
import { validateLoadMore, parseDateTime } from 'services/Utils';
import { textLang } from 'services/Lang';

// Components
import PackagesModal from './PackagesModal';

const Membership = ({object, refetchUser}) => {
	const [transactions, setTransactions] = useState([]);
    const [metaTransactions, setMetaTransactions] = useState([]);
    const limit = 10;
    const [offset, setOffset] = useState(0);

    const { refetch, isFetching } = useQuery({
	    queryKey: ['data-transactions', offset],
	    queryFn: async () => {
	      const params = {
	        offset,
	        limit
	      };

	      const response = await apiService.getTransactions(params);
	      if (offset === 0) {
		    setTransactions(response.data);
	      } else {
	      	setTransactions((prev) => [...prev, ...response.data]);
	      }

	      setMetaTransactions(response.meta);

	      refetchUser();
	      
	      return true;
	    },
	    refetchOnWindowFocus: false,
	    retry: false,
  	});

  	const loadMore = async () => {
	  setOffset((prev) => prev + limit);
	};

	const parseTransactionTitle = (type) => {
	  switch (type) {
	    case 'topUp':
	      return textLang('Balance Refill');
	    case 'likedUser':
	      return textLang('Like User');
	    case 'superLikedUser':
	      return textLang('Super Like User');
	    case 'likedGroup':
	      return textLang('Like Group');
	    case 'openUserLike':
	      return textLang('Opened User Like');
	    case 'openGroupLike':
	      return textLang('Opened Group Like');
	    case 'spinWheel':
	      return textLang('Spin the Wheel');
	    case 'bonus':
	      return textLang('Bonus Reward');
	   	case 'paid':
	      return textLang('Paid');
	    case 'games':
	      return textLang('Spin Wheel');
	    case 'createGroup':
	      return textLang('Created Group');
	    default:
	      return textLang('Transaction');
	  }
	};

	//const { isOpen, onOpen, onClose } = useDisclosure();

	return (
		<Box 
			maxH="100vh" 
			pt="16px" 
			pb="350px" 
			overflowY="auto">
			<Box bg="white" p="20px" borderRadius="16px">
			    <Text variant="title-lg">{textLang('balance_header')}</Text> 
			    <Text mt="16px">
			    	{textLang('balance_text')}
			    </Text>
			</Box>

			<Box position="relative" mt="16px" bg="#ff4133" p="20px" borderRadius="16px">
				<Text variant="text-md" color="white">{textLang('balance')}</Text>
				<Flex gap="8px" mt="0px" alignItems="center">
					<Text pr="6px" variant="title-lg" fontSize="44px" fontStyle="italic" fontWeight="900" color="white">
						{object?.balance + object?.balanceDaily || 0}
					</Text>
				</Flex>
				<Button 
				  bg="white" 
				  w="50%" 
				  mt="24px" 
				  color="#ff4133" 
				  zIndex="999"
				  as="a" 
				  href="tg://resolve?domain=megameet_bot&start=pay"
				  target="_blank" 
				>
					{textLang('balance_top_up')}
				</Button>

				<Box zIndex="1" position="absolute" top="0" right="0px" h="100%" w="100%" className="animation-balance">
					<Box className="animation-balance-gem" alt="Gem" position="absolute" 
						zIndex="2" right="-6px" bottom="31px">
						<SiCrystal fontSize="30px" color="#f1f1f1" />
					</Box>

			        <Box className="animation-balance-gem-blur" alt="Gem Blur" position="absolute" 
			        	zIndex="2" right="107px" bottom="42px" >
			        	<SiCrystal fontSize="60px" color="#f1f1f1" />
					</Box>

			        <Box className="animation-balance-gem-coin" alt="Crystal" position="absolute" 
			        	zIndex="1" right="-25px" bottom="65px" transform="rotate(25deg)" >
			        	<SiCrystal fontSize="140px" color="#f1f1f1" />
					</Box>
				</Box>
			</Box>

			<Text variant="title-lg" 
	          fontWeight="800"
	          mt="24px"
	          mb="0px"
	          textTransform="uppercase"
	          fontSize="24px">{textLang('balance_activity')}</Text>

	        <Box position="relative" mt="8px" bg="white" p="20px" borderRadius="16px">

			{ transactions?.length > 0 && transactions?.map((item, index) => (
	            <Flex key={index} justifyContent="space-between" mb="16px">
	            	<Box>
	            		<Text variant="title-md">
					      {parseTransactionTitle(item.type)}
					    </Text>
	            		<Text variant="text-md">{parseDateTime(item.createdAt)}</Text>
	            	</Box>
            		<Flex gap="4px">
            			<Text variant="title-lg">{item.amount}</Text>
            			<SiCrystal fontSize="21px" color={ item?.type === 'pending' ? '#FADA52' : 'red'} />
            		</Flex>
        		</Flex>
	        ))}

	        { !isFetching && transactions?.length === 0 && <Text>{textLang('transactions_empty')}</Text>}

	        { validateLoadMore(transactions, metaTransactions) && (
		        <Button variant="button-md"
		        	transform="translate(-50%, 0)"
		        	left="50%"
		        	maxW="220px" onClick={loadMore} m="0px auto !important" disabled={isFetching ? true : false} isLoading={isFetching}>
		          {textLang('load_more')}
		        </Button>
		    )}

		    </Box>

		    {/*<PackagesModal
		      userData={object}
		      isOpen={isOpen}
		      onClose={onClose}
		    />*/}

		</Box>
	);
};

export default Membership;